import { usePersistentData } from '../usePersistentData';

// IF YOU COPY-PASTE THIS FILE TO ANOTHER FILE, CHANGE THIS
const KEY = 'REPEAT_FAILURE_ORDER_RESCHEDULE_FORM_DATA';

// IF YOU ADJUST THE LOGIC OF THE HOOK IN THIS FILE, CHANGE THIS
const VERSION = '1';

interface PersistedData {
  instructions: string;
  is_doorman: boolean;
}

export function useRepeatFailureOrderRescheduleFormData() {
  const { data, setData } = usePersistentData(`${KEY}.${VERSION}`);
  let dataObj = data ? (JSON.parse(data) as PersistedData) : null;

  return {
    persistedFormData: dataObj,
    setPersistedFormData: (newContext: PersistedData) => {
      setData(newContext);
      dataObj = newContext;
    },
  };
}
